import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { switchToRegistration, closeAllModals } from '../../redux/authSlice';
import ApiManagerCustomer from '../../api-manager/ApiManagerCustomer.component';
import "./SelectionStyles.css";

const RegisterUserSelection = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn === "true") {
      dispatch(closeAllModals());
    }
  }, [dispatch]);
 
  if (!isOpen || localStorage.getItem("isLoggedIn") === "true") return null;

const handleUser = async () => {
    const tempStore = localStorage.getItem("tempUserData");
    console.log(" Selection Screen - Temp Data Check:", tempStore);

    try {
      if (tempStore) {
        const data = JSON.parse(tempStore);
        
        // Final flags set karo login ke liye
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userData", JSON.stringify(data));
        
        // Mapping check again
        if(data.mobile) localStorage.setItem("phoneNumber", data.mobile);
        
        // Cleanup temp data
        localStorage.removeItem("tempUserData"); 
        dispatch(closeAllModals());

        // --- INSTANT REFRESH ---
        window.location.href = "/";
      } else {
        // Agar tempStore khali hai, matlab Backend ne data nahi diya
        console.log(" No temp data found. Redirecting to Registration Form.");
        dispatch(switchToRegistration());
      }
    } catch (e) {
      console.error(" Selection Process Error:", e);
      dispatch(switchToRegistration());
    }
  };  

  // const handleAstrologer = () => {
  //   dispatch(closeAllModals());
  //   navigate('/astrologer-registration');
  // };
  
  const handleAstrologer = () => {
  const tempStore = localStorage.getItem("tempUserData");

  if (!tempStore) {
    
    console.log("New user detected as astrologer. Redirecting to app download.");
    dispatch(closeAllModals());
    navigate('/app-download'); 
  } else {
   
    console.log("Existing user detected. Proceeding to registration/login.");
    dispatch(closeAllModals());
    navigate('/astrologer-registration');
  }
};

  return (
    <div className="auth-overlay">
        <div className="cosmic-nebula"></div>
        <div className="cosmic-stars"></div>
        <div className="shooting-star"></div>
        <div className="shooting-star"></div>

        <div className="auth-box">
          <button className="close-x" onClick={onClose}>&times;</button>
          <div className="ab-logo-universe-box">
            <img src={require("../../assets/AstrobhagyaLogoo.webp")} alt="logo" className="m-logo animated-logo" />
            <img src={require("../../assets/AstrobhagyaName.webp")} alt="name" className="m-name" />
          </div>

          <h2 className="selection-title-cosmic">GET STARTED</h2>
          <p className="selection-desc-cosmic">Please choose your account type to proceed</p>

          <div className="selection-button-stack">
            <button className="m-continue selection-btn-fix" onClick={handleUser}>
              I AM A USER
            </button>
            <button className="selection-outline-btn" onClick={handleAstrologer}>
              I AM AN ASTROLOGER
            </button>
          </div>
        </div>
    </div>
  );
};

export default RegisterUserSelection;